<input
  #flatpickrTarget
  id="flatpickr-input"
  hidden
/>
